module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/1caced4fca1868d6c5db1e23800eca3e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_group_arrow_active.svg
// module id = 885l
// module chunks = 1